<template>
  <Layer @close="$emit('close')" title="Store Product">
    <div class="add-stock-layer">
      <ProductShelfTeaser :product="product" :shelfSpaceId="shelfSpaceId" />
      <form @submit.prevent="submitForm" v-if="productId && shelfSpaceId">
        <div class="form-group">
          <label for="amount">Amount</label>
          <input
            type="text"
            inputmode="numeric"
            required
            v-model="amount"
            id="amount"
            class="form-control"
            autocorrect="off"
            autocomplete="off"
            ref="amount"
          />
        </div>
        <DateField
          v-if="categoryHasExpiryDate(product.categoryId)"
          label="Expiry Date"
          :value="expiryDate"
          @input="handleExpiryDate"
          style="margin: 0 0 1rem;"
          required
        />
        <div style="text-align: right;">
          <button :disabled="!shelfSpaceId || !product || !amount" class="btn btn-primary">
            Store
          </button>
        </div>
      </form>
      <Scanner :expectations="['ean', 'productId', 'shelfSpace']" :redirect="{ all: false }" @scan="handleScan" />
    </div>
  </Layer>
</template>

<script>
import ProductShelfTeaser from '@/components/ProductShelfTeaser'
import Scanner from '@/components/Scanner'
import Warehouse from '@/controllers/Warehouse'
import DateField from '@/shared/DateField'
import Layer from '@/shared/Layer'

export default {
  components: { Layer, ProductShelfTeaser, Scanner, DateField },
  data() {
    return {
      productId: null,
      product: null,
      shelfSpaceId: null,
      amount: null,
      expiryDate: null
    }
  },
  props: {
    initialProductId: {
      type: String,
      default: null
    },
    initialShelfSpaceId: {
      type: String,
      default: null
    }
  },
  created() {
    if (this.initialProductId) {
      this.productId = _.cloneDeep(this.initialProductId)
      this.product = _.find(this.$store.state.products, { id: this.initialProductId })
    }
    this.shelfSpaceId = this.initialShelfSpaceId.replace('SH-', '')
  },
  methods: {
    handleScan(scan) {
      if (scan.validTypeFound === 'shelfSpace') {
        // legacy lösung
        const oldShelf = /^[A-Z][0-9][0-9][0-9]$/.test(scan.q)
        if (oldShelf) {
          scan.q = `SH-${scan.q.substr(0, 1)}0${scan.q.substr(1, 1)}-${scan.q.substr(2, 2)}`
        }
      }
      switch (scan.validTypeFound) {
        case 'ean':
        case 'productId':
          this.productId = scan.data.id
          this.product = scan.data
          this.amount = scan.data.amount > 1 ? scan.data.amount : null
          break
        case 'shelfSpace':
          this.shelfSpaceId = scan.q.replace('SH-', '')
          break
      }
      setTimeout(() => {
        if (this.productId && this.shelfSpaceId) this.$refs.amount.focus()
      }, 100)
    },
    handleExpiryDate(val) {
      this.expiryDate = val
    },
    categoryHasExpiryDate(categoryId) {
      return ['B', 'E', 'F', 'I'].includes(categoryId.substring(0, 1)) && categoryId !== 'EE'
    },
    submitForm() {
      const amount = parseFloat(this.amount)
      const expiryDate = this.categoryHasExpiryDate(this.product.categoryId) && this.expiryDate ? this.expiryDate : null
      let confirmed = true
      if (!isNaN(amount) && amount > 1000) {
        confirmed = confirm(`Are you sure you want to add ${amount} items?`)
      }
      if (confirmed) {
        const { shelfSpaceId, productId } = this
        Warehouse.addStock({
          shelfId: shelfSpaceId.split('-')[0],
          spaceId: shelfSpaceId.split('-')[1],
          productId,
          amount,
          expiryDate
        })
        this.$emit('close')
      } else {
        this.amount = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-stock-layer {
  padding: 2rem;
}
</style>
